module.exports = __webpack_public_path__ + "img/icon-name.226e0b50.svg";